<template>
  <div>
    <table data-pdfmake="{'layout':'noBorders', 'widths': ['50%', '50%']}">
      <tr class="noBorders">
        <td class="noBorders">
          <h3 class="text-center">Спецификация</h3>
          <p class="text-center font-italic">
            номер {{ specification.spec_number }}
          </p>
          <div class="my-2">
            <table
              data-pdfmake="{'layout':'noBorders', 'widths': ['*', 20, '*']}"
            >
              <tr>
                <td>
                  <strong>Место заключения</strong>
                  <br />
                  {{ specification.spec_place }}
                </td>
                <td></td>
                <td>
                  <strong>Дата подписания</strong>
                  <br />
                  {{ specification.spec_date }}
                </td>
              </tr>
            </table>
          </div>
          <div class="row">
            <div class="col-md-6">
              {{ buyer.organizations.org_name }},
              {{ buyer.org_residency.display_text }}, именуемое в дальнейшем
              «Покупатель», в лице {{ buyer.persons.given_name }}
              {{ buyer.persons.last_name }}, действующего на основании, с одной
              стороны, и {{ seller.organizations.org_name }},
              {{ seller.org_residency.display_text }}, именуемое в дальнейшем
              «Продавец», в лице {{ seller.persons.given_name }}
              {{ seller.persons.last_name }}, действующего на основании, с
              другой стороны, заключили настоящую Спецификацию о нижеследующем:
              1. Продавец продает,а Покупатель покупает на условиях
              {{ specification.inkoterms }} (Инкотермс 2010) следующий Товар
              оборудование:
            </div>
          </div>
        </td>
        <td class="noBorders">
          <h3 class="text-center">Specification</h3>
          <p class="text-center font-italic">
            number: {{ specification.spec_number }}
          </p>
          <div class="my-2">
            <table
              data-pdfmake="{'layout':'noBorders', 'widths': ['*', 20, '*']}"
            >
              <tr>
                <td>
                  <strong>Signed in</strong>
                  <br />
                  {{ specification.spec_place }}
                </td>
                <td></td>
                <td>
                  <strong>Date</strong>
                  <br />
                  {{ specification.spec_date }}
                </td>
              </tr>
            </table>
          </div>
          <div class="row">
            <div class="col-md-6">
              {{ buyer.organizations.org_name }},
              {{ buyer.org_residency.display_text }}, hereinafter referred to as
              the Buyer, in the name of {{ buyer.persons.given_name }}
              {{ buyer.persons.last_name }}, on the one hand, and
              {{ seller.organizations.org_name }},
              {{ seller.org_residency.display_text }} hereinafter referred to as
              Bargainer in the name of {{ seller.persons.given_name }}
              {{ seller.persons.last_name }}, on the other hand, have concluded
              the present Specification as follows: 1. The Bargainer has sold
              and the Bargainee has bought the following goods on conditions
              {{ specification.inkoterms }} (Incoterms 2010) :
            </div>
          </div>
        </td>
      </tr>
    </table>
    <br /><br />
    <div class="my-2">
      <table class="table table-bordered" style="font-size: 11px">
        <tr>
          <th>Наименование / Description of goods</th>
          <th>Кол-во (шт)/ Qnt. (pcs.)</th>
          <th>Цена за 1 шт, Евро/Условия по INCOTERMS Price per 1 pcs, EUR</th>
          <th>Сумма, Евро / Total price, EUR</th>
        </tr>
        <tr v-for="(product, i) in specification.goods" :key="i">
          <td>
            {{ product.spec_good_name }}
            <span>Модель: {{ product.spec_good_model }}</span
            ><br />
            <span
              >Серийный номер / Марка: {{ product.spec_good_serialnum }} /
              {{ product.spec_good_mark }}</span
            ><br />
            <span
              >Производитель / Страна происхождения:
              {{ product.spec_good_manufacturer }} /
              {{ product.spec_good_orign }}</span
            >
            <hr />
            <span>Type: {{ product.spec_good_model }}</span
            ><br />
            <span
              >Serial number / Make: {{ product.spec_good_serialnum }} /
              {{ product.spec_good_mark }}</span
            ><br />
            <span
              >Manufacturer / Country of origin:
              {{ product.spec_good_manufacturer }} /
              {{ product.spec_good_orign }}</span
            >
          </td>
          <td>{{ product.spec_good_quant }}</td>
          <td>
            {{ product.spec_good_price }}, {{ product.spec_good_code }} /
            {{ specification.inkoterms }}
          </td>
          <td>{{ product.spec_good_price * product.spec_good_quant }}</td>
        </tr>
      </table>
      <div class="w-50 ml-auto"></div>
    </div>
    <canvas id="signature_canvas"></canvas>
  </div>
</template>
<script>
import moment from "moment";
var QRCode = require("qrcode");
export default {
  props: ["user_id", "doc_id"],
  data() {
    return {
      оrganizations: {},
      xml: "",
      ecp_storage: "",
      document_number: "-",
      invoice: {},
      currencies: [],
      specification: {},
      buyer: {
        organizations: {
          org_name: "",
        },
        persons: {
          given_name: "",
          last_name: "",
          position: "",
          post_address: "",
          country: "",
          person_phone_number: "",
          org_code: "",
        },
        org_residency: {
          display_text: "",
        },
      },
      seller: {
        organizations: {
          org_name: "",
        },
        persons: {
          given_name: "",
          last_name: "",
          position: "",
          post_address: "",
          country: "",
          person_phone_number: "",
          org_code: "",
        },
        org_residency: {
          display_text: "",
        },
      },
    };
  },
  mounted() {
    axios
      .get(
        window.base +
          "/library?type=currency&query=&qty=10000" +
          "&lang=" +
          this.$i18n.locale,
      )
      .then((response) => {
        this.currencies = response.data;
        axios
          .get(
            window.base + "/document/LoadSpecification?doc_id=" + this.doc_id,
          )
          .then((response) => {
            this.specification = response.data;
            axios
              .get(
                window.base +
                  "/document/getFirmbyBin?bin=" +
                  this.specification.attis_contract_byer,
              )
              .then((response) => {
                this.buyer = response.data;
                axios
                  .get(
                    window.base +
                      "/document/getFirmbyBin?bin=" +
                      this.specification.attis_contract_seller,
                  )
                  .then((response) => {
                    this.seller = response.data;
                    axios
                      .get(window.base + "/contract/pdfNumber")
                      .then((response) => {
                        this.document_number = response.data;
                        setTimeout(() => {
                          console.log("called print pdf specification");
                          this.$root.$emit("print-pdf", {
                            signature: {},
                            type: "specification",
                          });
                        }, 1000);
                        // axios.get(window.base + '/document/LoadSignature?doc_id='+this.doc_id).then(response=>{
                        //     if(typeof response.data.signature !== 'undefined'){
                        //         // console.log("as")
                        //         if(response.data.signature==''){
                        //             this.$root.$emit('print-pdf', {signature: '', type: 'invoice'})
                        //             new Noty({
                        //                 theme: 'light',
                        //                 type: 'error',
                        //                 text: this.$t('message.contracts.no-signature-message'),
                        //                 timeout: 5000,
                        //             }).show();
                        //         }else{
                        //             var canvas = QRCode.toCanvas(response.data.signature, {width: 100, height: 100})
                        //             canvas.then((r)=>{
                        //                 // this.check_signature(value, ()=>{
                        //                     this.$root.$emit('print-pdf', {signature: r, type: 'invoice'})
                        //                     new Noty({
                        //                         theme: 'light',
                        //                         type: 'success',
                        //                         text: this.$t('message.contracts.yes-signature-message'),
                        //                         timeout: 5000,
                        //                     }).show();
                        //                     // window.webSocket.removeEventListener('message', {})
                        //                 // })
                        //             })
                        //         }
                        //     }else{
                        //         // console.log("bs")
                        //         this.$root.$emit('print-pdf', {signature: '', type: 'invoice'})
                        //         new Noty({
                        //             theme: 'light',
                        //             type: 'error',
                        //             text: this.$t('message.contracts.no-signature-message'),
                        //             timeout: 5000,
                        //         }).show();
                        //     }
                        // })

                        /*axios.get(window.base + '/document/LoadInvoiceXML?doc_id='+this.doc_id).then(response=>{
                                this.xml = response.data.replace('<?xml version="1.0" encoding="utf-16"?>', '')
                                window.webSocket = new WebSocket('wss://127.0.0.1:13579/');
                                window.callback = null;

                                window.webSocket.onopen = (event)=>{
                                    console.log("Connection opened");
                                    // window.getKeyInfo("PKCS12", (r)=>{
                                    //     console.log('info', r)
                                    // })
                                    window.signXml("PKCS12", "SIGNATURE", this.xml, (tmp)=>{
                                        // console.log(tmp)
                                    });
                                };

                                window.webSocket.onclose = function (event) {
                                    if (event.wasClean) {
                                        console.log('connection has been closed');
                                    } else {
                                        console.log('Connection error');
                                        openDialog();
                                    }
                                    console.log('Code: ' + event.code + ' Reason: ' + event.reason);
                                };

                                window.webSocket.onmessage = (event) => {
                                    var result = JSON.parse(event.data);
                                    // console.log(result, event)
                                    if (result != null) {
                                        var rw = {
                                            code: result['code'],
                                            message: result['message'],
                                            responseObject: result['responseObject'],
                                            getResult: function () {
                                                return this.result;
                                            },
                                            getMessage: function () {
                                                return this.message;
                                            },
                                            getResponseObject: function () {
                                                return this.responseObject;
                                            },
                                            getCode: function () {
                                                return this.code;
                                            }
                                        };
                                        this.callback(rw)
                                    }
                                };
                            })*/
                      });
                  });
              });
          });
      });
  },
  methods: {
    /**
     * Checks if newly generated signature is similar to the one previously saved on the server.
     * If got true – everything ok, can download file, if false – then the document
     * has not been signed yet or has been changed after signing.
     */
    check_signature(signature, callback) {
      var fd = new FormData();
      fd.append("contract_id", this.doc_id);
      fd.append("signature", signature);
      axios.post(window.base + "/document/CheckSignature", fd).then((r) => {
        if (r.data == "False") {
          new Noty({
            theme: "light",
            type: "error",
            text: this.$root.$t("message.message.document_signature_is_wrong"),
            timeout: 5000,
          }).show();
        } else {
          new Noty({
            theme: "light",
            type: "success",
            text: this.$root.$t("message.message.document_signature_is_ok"),
            timeout: 5000,
          }).show();
          callback();
        }
      });
    },
    callback(r) {
      console.log(r);
      if (r.code == "200") {
        // console.log(r)
        var oParser = new DOMParser();
        var oDOM = oParser.parseFromString(
          r.getResponseObject(),
          "application/xml",
        );
        var value = oDOM.getElementsByTagName("ds:SignatureValue")[0].innerHTML;
        var canvas = QRCode.toCanvas(value, { width: 100, height: 100 });
        canvas.then((r) => {
          this.check_signature(value, () => {
            this.$root.$emit("print-pdf", { signature: r, type: "invoice" });
            window.webSocket.close();
          });
        });
      }
    },
  },
  computed: {
    date() {
      return moment().format("D.MM.Y");
    },
    currency() {
      var c = "";
      if (typeof this.invoice.CurrencyCode !== "undefined")
        this.currencies.forEach((item) => {
          if (item.value == this.invoice.CurrencyCode.trim()) {
            c = item.display_text;
          }
        });
      return c;
    },
  },
};
</script>
